// Products can optionally be sold as a digital download alongside the
// physical item (e.g. vinyl LP vs. WAV download), each with its own price.

export const hasDownloadOption = (product) =>
  !!(product && product.downloadEnabled && Number(product.downloadPrice) > 0);

export const getPhysicalLabel = (product) =>
  (product && product.physicalLabel) || 'Physical copy';

export const getDownloadLabel = (product) =>
  (product && product.downloadLabel) || 'Digital download';

// Build the basket entry for a product. Download variants get their own
// cart id so the physical and download versions sit on separate lines.
export const buildCartItem = (product, variant = 'physical') => {
  const withOptions = hasDownloadOption(product);
  if (variant === 'download') {
    return {
      ...product,
      id: `${product.id}__download`,
      productId: product.id,
      variant: 'download',
      name: `${product.name} – ${getDownloadLabel(product)}`,
      price: Number(product.downloadPrice) || 0,
      postage: null,
      inStock: true,
    };
  }
  return {
    ...product,
    productId: product.id,
    variant: 'physical',
    name: withOptions ? `${product.name} – ${getPhysicalLabel(product)}` : product.name,
    price: product.price || 0,
    inStock: product.inStock !== false,
  };
};
